import React from "react";
import { Link } from "react-router-dom";

const WhatsAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M4.83574 12.3296L5.31889 12.6113C6.12606 13.082 7.0434 13.3333 8.00066 13.3333C10.9462 13.3333 13.334 10.9455 13.334 7.99998C13.334 5.05446 10.9462 2.66665 8.00066 2.66665C5.05513 2.66665 2.66732 5.05446 2.66732 7.99998C2.66732 8.95751 2.9188 9.87518 3.38977 10.6825L3.67136 11.1652L3.2357 12.7662L4.83574 12.3296ZM1.33677 14.6666L2.23808 11.3543C1.66329 10.369 1.33398 9.22298 1.33398 7.99998C1.33398 4.31808 4.31875 1.33331 8.00066 1.33331C11.6825 1.33331 14.6673 4.31808 14.6673 7.99998C14.6673 11.6818 11.6825 14.6666 8.00066 14.6666C6.77806 14.6666 5.63234 14.3376 4.64724 13.7631L1.33677 14.6666Z"
      fill="white"
    />
  </svg>
);

const buildWhatsAppLink = (number, prefilledText) => {
  if (!number) return "#contact";

  // Strip non-digits except leading +
  const cleanNumber = String(number)
    .replace(/[^\d+]/g, "")
    .replace(/^\+/, "");
  const encodedText = encodeURIComponent(prefilledText || "");

  return `https://wa.me/${cleanNumber}${encodedText ? `?text=${encodedText}` : ""}`;
};

const HallCard = ({ card }) => {
  const { slug, title, imageUrl, whatsappNumber, whatsappPrefilledText } = card;

  const whatsappLink = buildWhatsAppLink(whatsappNumber, whatsappPrefilledText);

  return (
    <div className="col-5th">
      <figure className="img-container">
        <Link to="/mamangam-hall-booking-details" state={{ initialTab: slug }}>
          <img src={imageUrl} className="w-100 img-fluid" alt={title} />
        </Link>
        <figcaption>
          <h4>{title}</h4>
          <a
            href={whatsappLink}
            className="connect-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon />
            Contact
          </a>
        </figcaption>
      </figure>
    </div>
  );
};

export default HallCard;
